var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from 'react';
import { Button } from '@trustpilot/businessapp-patternlibrary';
import { Auth } from '../Auth';
var ExternalAuthentication = function (_a) {
    var trustpilotDomain = _a.trustpilotDomain, appClientId = _a.appClientId, redirectUri = _a.redirectUri, cookiesDomain = _a.cookiesDomain, authenticationApiUrl = _a.authenticationApiUrl, source = _a.source, locale = _a.locale, integrationConfig = _a.integrationConfig, onLoggedIn = _a.onLoggedIn, onSignedUp = _a.onSignedUp;
    var _b = useState(false), inProgress = _b[0], setInProgress = _b[1];
    var openPopUp = useCallback(function () {
        setInProgress(true);
        try {
            var width = 600;
            var height = 770;
            var y = window.outerHeight / 2 + window.screenY - (height / 2);
            var x = window.outerWidth / 2 + window.screenX - (width / 2);
            var parameters = new URLSearchParams({
                redirect_uri: redirectUri,
                client_id: appClientId,
                locale: locale || 'en-US',
                response_type: 'code',
                cookie_domain: cookiesDomain,
                flow: 'popup',
                source: 'ecomm',
            });
            if (source) {
                var lowercase = source.toLowerCase();
                parameters.append('utm_source', lowercase);
                parameters.append('utm_campaign', lowercase);
                parameters.append('utm_medium', 'appstore');
            }
            if (integrationConfig) {
                var integrationConfigParameter = btoa(JSON.stringify(integrationConfig));
                parameters.append('integration_config', integrationConfigParameter);
            }
            var LOGIN_URL = "https://authenticate." + trustpilotDomain;
            var FULL_LOGIN = LOGIN_URL + "?" + parameters.toString();
            var popUp_1 = window.open(FULL_LOGIN, 'trustpilot-login', "toolbar=no, menubar=no, width=" + width + ", height=" + height + ", left=" + x + ", top=" + y);
            var timer_1 = setInterval(function () {
                if (!popUp_1 || popUp_1.closed) {
                    clearInterval(timer_1);
                    setInProgress(false);
                }
            }, 1000);
            window.onmessage = function (e) {
                if (!e.data) {
                    return;
                }
                if (e.data.name === 'login-success') {
                    var code = e.data.code;
                    Auth.loginWithAuthorizationCode(code, cookiesDomain, authenticationApiUrl).then(function (_a) {
                        var loggedIn = _a.loggedIn;
                        clearInterval(timer_1);
                        if (onLoggedIn) {
                            onLoggedIn(loggedIn);
                        }
                    });
                }
                else if (e.data.name === 'signup-success') {
                    var cleanedEvent = __assign(__assign({}, e.data), { name: undefined });
                    if (onSignedUp) {
                        onSignedUp(cleanedEvent);
                    }
                }
            };
        }
        catch (e) {
            setInProgress(false);
        }
    }, [trustpilotDomain, appClientId, redirectUri, cookiesDomain, authenticationApiUrl, source, locale, integrationConfig, onLoggedIn]);
    return React.createElement(Button, { loading: inProgress, disabled: inProgress, onClick: openPopUp }, "Log in with Trustpilot");
};
export default ExternalAuthentication;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Containers/ExternalAuthentication.js
// module id = 1364
// module chunks = 0